<template>
<div class="vert-tabs">

   <nav class="">
      <a
      v-for="vTab in this.vTabs"
      :key="vTab.id"
      :class="[vertTabClass,
      (currentVertTab === vTab.id) ? vertTabActiveClass : '',
      vTab.complete ? vertTabCompleteClass : '']"
      >
         <!-- For a future proofed design check if a function can be passed to determine the displayed output making it a better re-usable component -->
         <div :class="['row', vTab.disable ? vertTabDisabledClass : '']"
               @click="sendVTab(vTab)"
         >
            <div class="col no-padding vert-syms">
               <!-- <i class="vert-check check-circle fad fa-check-circle fa-lg"></i> -->
               <span v-if="vTab.complete && currentVertTab!=vTab.id" class="fa-stack">
                 <i class="fal fa-circle fa-mx fa-stack theme-calc green"></i>
                  <i class="fal fa-check fa-sx fa-stack-1x"></i>
               </span>
               <span v-else-if="currentVertTab!=vTab.id" class="fa-stack">
                  <i class="fal fa-circle fa-sm theme-calc rev"></i>
               </span>
               <div v-show="currentVertTab===vTab.id" class="green-bar"></div>
               <div :class="(currentVertTab === vTab.id) ? 'side-bar current' : 'side-bar'"></div>
            </div>
            <div class="col no-left-padding">
               <div class="name">{{vTab.name}}</div>
               <div class="sub-name" v-if="vTab.subName">{{ vTab.subName }}</div>
               <div class="description" v-if="currentVertTab === vTab.id">{{ vTab.description }}</div>
            </div>
         </div>
         <div class="spacing"></div>
      </a>
   </nav>
</div>
</template>

<script>
   import { mapGetters } from 'vuex'

   export default {
      props: {
         /*
         * steps must been an array of objects; each containing:
         * id (int), name (string), description (string), subname (string), ref (string), enabled (bool), complete (bool)
         *
         */
         vTabs:{
            type: Array,
            required: true,
         },
         // current step is the ID of the current step
         currentVertTab:{
            type: Number,
            required: true,
         },
      },
      data: function(){
         // each class for ease of change is a data element
         return {
            vertTabClass: 'item',
            vertTabActiveClass: 'active',
            vertTabDisabledClass: 'disabled',
            vertTabCompleteClass: 'complete'
         }
      },
      methods: {
         //event handler when the tabs are clicked
         sendVTab(data){
            this.$emit('click', data);
         },
      }
   }
</script>
